module.exports = require('./helpers/bundle-url').getBundleURL('sif1r') + "background.7652ee9a.svg";